import { Button } from "lqx-react";
import React from "react";

export const FileDownloadButton = ({ color, file, fileName, text, downloadAction, icon }:
  { color?: any, file?: File, fileName?: string, text?: string, downloadAction?: any, icon?: string }) => {

  const download = async (file: File, fileName: string) => {
    const dataUrl = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = fileName;
    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    a.click();
    a.remove();  //afterwards we remove the element again
  }

  const getButtonText = () => text ? text : 'Download';

  return (
    icon ?
      <i className="fa fa-download pointer"
        onClick={() => { downloadAction ? downloadAction() : download(file, fileName ? fileName : file.name); }}
      ></i>
      :
      <Button color={color ? color : 'primary'}
        onClick={() => { downloadAction ? downloadAction() : download(file, fileName ? fileName : file.name); }}>
        {getButtonText()}
      </Button>
  );
}
